import { formatDate } from '@fukuri-admins/utils/common/date';
import React from 'react';
import {
  CompanyDepositProvisionalType,
  CompanyDepositType,
} from '~/types/resources/CompanyDepositType.ts';
import { formatCurrency } from '../../../utils/formatCurrency';
import styles from './styles.module.scss';

type Props = {
  row: CompanyDepositProvisionalType | CompanyDepositType;
};

export const CompanyDepositCard: React.FC<Props> = ({ row }) => {
  return (
    <div className={styles.card}>
      <div className={styles.date}>
        {'deposited_at' in row
          ? '先月入金額'
          : `${formatDate({ date: new Date(row.target_month), formatType: 'yyyy年M月' })}入金予定金額`}
      </div>
      <div className={styles.amount}>{formatCurrency(row.amount)}</div>
    </div>
  );
};
